export default class Image {
    constructor(filename) {
        this.baseUri = '/images/';
        this.filename = filename;
    }

    getPath() {
        return this.baseUri + this.filename;
    }
}